<template>
  <button :class="['switch-toggle', { 'switch-on': checked, 'switch-off': !checked, 'switch-disabled': disabled }]"
          role="switch"
          :aria-checked="checked"
          :disabled="disabled"
          @click.prevent="onToggle">
    <span class="switch-track"></span>
    <span class="switch-thumb" aria-hidden="true"></span>
  </button>
</template>

<script>
export default {
  name: 'SwitchToggle',
  props: {
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['change'],
  methods: {
    onToggle() {
      if (this.disabled) return;
      this.$emit('change', !this.checked);
    }
  }
}
</script>

<style scoped>
.switch-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 24px;
  border-radius: 9999px;
  padding: 2px;
  background: #e5e7eb; /* gray-200 */
  border: none;
  cursor: pointer;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.2);
}
.switch-on {
  background: #10b981; /* green */
}
.switch-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.switch-thumb {
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  transform: translateX(-10px);
  transition: transform 0.15s ease;
}
.switch-on .switch-thumb {
  transform: translateX(10px);
}
</style>
